const steps = [
  {
    number: '01',
    title: 'We Target High-Intent Searches',
    desc: 'We identify exactly what your ideal customers are searching — phrases like "best plumber near me" or "emergency HVAC repair" — and put your business in front of them.',
  },
  {
    number: '02',
    title: 'Your Business Appears at the Top',
    desc: 'Your ad shows up at the very top of Google results, above organic listings, right when customers are ready to buy.',
  },
  {
    number: '03',
    title: 'Customers Call or Submit a Form',
    desc: 'They land on a page built to convert. No distractions. Just a clear message and a simple way to reach you.',
  },
  {
    number: '04',
    title: 'You Turn Leads Into Paying Clients',
    desc: 'You get the call, close the deal. We handle the marketing machine so you can focus on doing great work.',
  },
];

const HowItWorksSection = () => (
  <section id="how-it-works" className="bg-[#f8f9fa] py-24 md:py-32">
    <div className="max-w-6xl mx-auto px-6 md:px-10">
      <div className="text-center mb-16">
        <span className="text-orange-500 text-xs font-bold uppercase tracking-widest">The Process</span>
        <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 mt-3">How It Works</h2>
        <div className="w-16 h-1 bg-orange-500 mx-auto mt-5 rounded-full" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {steps.map((step, idx) => (
          <div key={step.number} className="relative">
            <div className="bg-white rounded-2xl p-8 h-full border border-gray-100">
              <div className="text-5xl font-black text-orange-100 leading-none mb-4">{step.number}</div>
              <h3 className="text-gray-900 font-bold text-lg mb-3 leading-snug">{step.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{step.desc}</p>
            </div>
            {idx < steps.length - 1 && (
              <div className="hidden lg:flex absolute top-1/2 -right-3 -translate-y-1/2 w-6 h-6 items-center justify-center z-10">
                <i className="ri-arrow-right-s-line text-orange-400 text-2xl" />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorksSection;
